<!-- 表1填写 -->

<template>
  <div class="tabCage table3">
    <div class="tabTtl">
      <span>表 1-3：经营情况表</span>
    </div>

    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>
    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <tr>
            <td colspan="2">项目</td>
            <td>{{ yearSet.year1 }}年</td>
            <td>{{ yearSet.year2 }}年</td>
          </tr>
          <tr>
            <td colspan="2">出版单位年销售收入（万元）</td>
            <td>
              <el-form-item prop="firstTotalSales" :show-message="false">
                <el-input-number v-model="params.firstTotalSales" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondTotalSales" :show-message="false">
                <el-input-number
                  v-model="params.secondTotalSales"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td colspan="2">出版单位年利润(税后)总额（万元）</td>
            <td>
              <el-form-item prop="firstTotalProfit" :show-message="false">
                <el-input-number
                  v-model="params.firstTotalProfit"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondTotalProfit" :show-message="false">
                <el-input-number
                  v-model="params.secondTotalProfit"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td rowspan="6">
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>年度销售收入（万元）
            </td>
            <td>
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>发行和销售收入
            </td>
            <td>
              <el-form-item prop="firstSales1" :show-message="false">
                <el-input-number
                  v-model="params.firstSales1"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales1" :show-message="false">
                <el-input-number
                  v-model="params.secondSales1"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>出让版权的收入</td>
            <td>
              <el-form-item prop="firstSales2" :show-message="false">
                <el-input-number
                  v-model="params.firstSales2"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales2" :show-message="false">
                <el-input-number
                  v-model="params.secondSales2"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>出版活动收入</td>
            <td>
              <el-form-item prop="firstSales3" :show-message="false">
                <el-input-number
                  v-model="params.firstSales3"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales3" :show-message="false">
                <el-input-number
                  v-model="params.secondSales3"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td>提供内容审校加工等<br />各种服务的收入</td>
            <td>
              <el-form-item prop="firstSales4" :show-message="false">
                <el-input-number
                  v-model="params.firstSales4"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales4" :show-message="false">
                <el-input-number
                  v-model="params.secondSales4"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>其他收入</td>
            <td>
              <el-form-item prop="firstSales5" :show-message="false">
                <el-input-number
                  v-model="params.firstSales5"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales5" :show-message="false">
                <el-input-number
                  v-model="params.secondSales5"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>合计</td>
            <td>
              <el-form-item prop="firstSales" :show-message="false">
                <el-input-number
                  v-model="params.firstSales"
                  disabled
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales" :show-message="false">
                <el-input-number
                  v-model="params.secondSales"
                  disabled
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td rowspan="9">
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>年度支出（万元）
            </td>
            <td>
              <span v-if="pressType == 1">音像</span
              ><span v-else-if="pressType == 2">电子</span>出版团队的<br />人员成本费用<br />（包括工资、福利、奖金等）
            </td>
            <td>
              <el-form-item prop="firstPay1" :show-message="false">
                <el-input-number
                  v-model="params.firstPay1"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay1" :show-message="false">
                <el-input-number
                  v-model="params.secondPay1"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>房租水电等<br />运营成本费用</td>
            <td>
              <el-form-item prop="firstPay2" :show-message="false">
                <el-input-number
                  v-model="params.firstPay2"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay2" :show-message="false">
                <el-input-number
                  v-model="params.secondPay2"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>获取内容及<br />审校加工等<br />各种劳务的支出</td>
            <td>
              <el-form-item prop="firstPay3" :show-message="false">
                <el-input-number
                  v-model="params.firstPay3"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay3" :show-message="false">
                <el-input-number
                  v-model="params.secondPay3"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td>印刷压盘<br />包装等费用</td>
            <td>
              <el-form-item prop="firstPay4" :show-message="false">
                <el-input-number
                  v-model="params.firstPay4"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay4" :show-message="false">
                <el-input-number
                  v-model="params.secondPay4"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>新媒体上的投入</td>
            <td>
              <el-form-item prop="firstPay5" :show-message="false">
                <el-input-number
                  v-model="params.firstPay5"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay5" :show-message="false">
                <el-input-number
                  v-model="params.secondPay5"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>固定资产投入</td>
            <td>
              <el-form-item prop="firstPay6" :show-message="false">
                <el-input-number
                  v-model="params.firstPay6"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay6" :show-message="false">
                <el-input-number
                  v-model="params.secondPay6"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>培训支出</td>
            <td>
              <el-form-item prop="firstPay7" :show-message="false">
                <el-input-number
                  v-model="params.firstPay7"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay7" :show-message="false">
                <el-input-number
                  v-model="params.secondPay7"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>其他支出</td>
            <td>
              <el-form-item prop="firstPay8" :show-message="false">
                <el-input-number
                  v-model="params.firstPay8"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay8" :show-message="false">
                <el-input-number
                  v-model="params.secondPay8"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>合计</td>
            <td>
              <el-form-item prop="firstPay" :show-message="false">
                <el-input-number
                  v-model="params.firstPay"
                  disabled
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay" :show-message="false">
                <el-input-number
                  v-model="params.secondPay"
                  disabled
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>年税费（万元）
              <br />
              <span style="color: red"
                >指与<span v-if="pressType == 1">音像制品</span
                ><span v-else-if="pressType == 2">电子出版</span>相关的企业所得缴纳税费，含营业税和所得税</span
              >
            </td>
            <td>
              <el-form-item prop="firstTax" :show-message="false">
                <el-input-number v-model="params.firstTax" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondTax" :show-message="false">
                <el-input-number v-model="params.secondTax" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>年度利润（税后）总额（万元）
            </td>
            <td>
              <el-form-item prop="firstProfit" :show-message="false">
                <el-input-number v-model="params.firstProfit" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondProfit" :show-message="false">
                <el-input-number v-model="params.secondProfit" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td colspan="2">获得基金类资助（万元）</td>
            <td>
              <el-form-item prop="firstFund" :show-message="false">
                <el-input-number v-model="params.firstFund" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondFund" :show-message="false">
                <el-input-number v-model="params.secondFund" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td colspan="2">主办主管单位给与的经费支持（万元）</td>
            <td>
              <el-form-item prop="firstSuperior" :show-message="false">
                <el-input-number v-model="params.firstSuperior" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSuperior" :show-message="false">
                <el-input-number v-model="params.secondSuperior" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr></tr>
          <tr>
            <td rowspan="3">
              <span v-if="pressType == 1">音像制品</span><span v-else-if="pressType == 2">电子出版物</span>出版品种
            </td>
            <td>载体出版</td>
            <td>
              <el-form-item prop="firstZtcbVariety" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbVariety"
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbVariety" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbVariety"
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>信息网络出版</td>
            <td>
              <el-form-item prop="firstWlcbVariety" :show-message="false">
                <el-input-number
                  v-model="params.firstWlcbVariety"
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondWlcbVariety" :show-message="false">
                <el-input-number
                  v-model="params.secondWlcbVariety"
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>合计</td>
            <td>
              <el-form-item prop="firstPublicationVariety" :show-message="false">
                <el-input-number
                  v-model="params.firstPublicationVariety"
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPublicationVariety" :show-message="false">
                <el-input-number
                  v-model="params.secondPublicationVariety"
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td rowspan="3">
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>经营情况<br />载体出版
            </td>
            <td>销售数量（套/张）</td>
            <td>
              <el-form-item prop="firstSalesVolumes" :show-message="false">
                <el-input-number
                  v-model="params.firstSalesVolumes"
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSalesVolumes" :show-message="false">
                <el-input-number
                  v-model="params.secondSalesVolumes"
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>年销售收入（万元）</td>
            <td>
              <el-form-item prop="firstZtcbSales" :show-message="false">
                <el-input-number v-model="params.firstZtcbSales" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbSales" :show-message="false">
                <el-input-number v-model="params.secondZtcbSales" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>年利润总额（万元）</td>
            <td>
              <el-form-item prop="firstZtcbProfit" :show-message="false">
                <el-input-number v-model="params.firstZtcbProfit" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondWlcbProfit" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbProfit"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td rowspan="5">
              <span v-if="pressType == 1">音像制品</span><span v-else-if="pressType == 2">电子出版物</span>
              <br />载体出版发行的渠道及占比

              <br /><span style="color: red">（请填写%之前的数值）</span>
            </td>
            <td>新华书店%</td>
            <td>
              <el-form-item prop="firstZtcbDistributionChanne" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbDistributionChanne"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbDistributionChanne" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbDistributionChanne"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td>馆配商%</td>
            <td>
              <el-form-item prop="firstZtcbDistributionChanne1" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbDistributionChanne1"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbDistributionChanne1" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbDistributionChanne1"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>邮局%</td>
            <td>
              <el-form-item prop="firstZtcbDistributionChanne2" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbDistributionChanne2"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbDistributionChanne2" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbDistributionChanne2"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td>其他%</td>
            <td>
              <el-form-item prop="firstZtcbDistributionChanne3" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbDistributionChanne3"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbDistributionChanne3" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbDistributionChanne3"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td>自办发行%</td>
            <td>
              <el-form-item prop="firstZtcbDistributionChanne4" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbDistributionChanne4"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbDistributionChanne4" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbDistributionChanne4"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td rowspan="2">
              <span v-if="pressType == 1">音像制品</span>
              <span v-else-if="pressType == 2">电子出版物</span>经营情况<br />
              信息网络出版
            </td>
            <td>年销售收入（万元）</td>
            <td>
              <el-form-item prop="firstWlcbSales" :show-message="false">
                <el-input-number v-model="params.firstWlcbSales" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondWlcbSales" :show-message="false">
                <el-input-number v-model="params.secondWlcbSales" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>年利润总额（万元）</td>
            <td>
              <el-form-item prop="firstWlcbProfit" :show-message="false">
                <el-input-number v-model="params.firstWlcbProfit" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbProfit" :show-message="false">
                <el-input-number
                  v-model="params.secondWlcbProfit"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td rowspan="2">
              <span v-if="pressType == 1">音像制品</span><span v-else-if="pressType == 2">电子出版物</span>
              <br />信息网络出版渠道及占比 <br /><span style="color: red">（请填写%之前的数值）</span>
            </td>
            <td>互联网网络营销平台%</td>
            <td>
              <el-form-item prop="firstWlcbDistributionChanne" :show-message="false">
                <el-input-number
                  v-model="params.firstWlcbDistributionChanne"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondWlcbDistributionChanne" :show-message="false">
                <el-input-number
                  v-model="params.secondWlcbDistributionChanne"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>自办发行%</td>
            <td>
              <el-form-item prop="firstWlcbDistributionChanne1" :show-message="false">
                <el-input-number
                  v-model="params.firstWlcbDistributionChanne1"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondWlcbDistributionChanne1" :show-message="false">
                <el-input-number
                  v-model="params.secondWlcbDistributionChanne1"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea newEditArea">
        <div class="editBox">
          <p class="edName">申报人：</p>
          <div class="edInp">
            <el-input size="small" v-model="declare.personnel" placeholder="请输入申报人"></el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">联系方式：</p>
          <div class="edInp">
            <el-input size="small" v-model="declare.contact" placeholder="请输入申报人联系方式"></el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">申报时间：</p>
          <div class="edInp">
            <el-input size="small" v-model="params.updatedAt" :disabled="true"></el-input>
          </div>
        </div>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="pubStatus == 0" type="primary" @click="editSave('paramCk')" size="small" :disabled="submiting">
        <span v-if="submiting">提交中</span>
        <span v-else>保存</span>
        <i v-if="submiting" class="el-icon-loading"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt3";
import { tabUpdate3, tabRead3 } from "@/api/pressRole/pressRole";
import Upbtn from "@/views/components/uploadCards";
export default {
  components: {
    Upbtn,
  },
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      submiting: false,
      pressType: this.$route.query.pressType,
      yearSet: {
        year1: "",
        year2: "",
      },
      declare: {
        personnel: "",
        contact: "",
      },
      pubStatus: 0,
    };
  },
  methods: {
    editSave: function (name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.declare.personnel == "") {
            this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //      this.$message.error("申报人手机号格式错误")
          //      return
          // }
          if (this.declare.contact == "") {
            this.$message.error("申报人联系方式必填");
            return;
          }
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;

          this.params.firstYear = this.yearSet.year1;
          this.params.secondYear = this.yearSet.year2;

          let bFirst = that.params.firstTotalSales > 500000;
          let bSecond = that.params.secondTotalSales > 500000;
          if (bFirst || bSecond) {
            that.$confirm("请确认年销售收入填写的是否正确。", "提示", {
              confirmButtonText: "确定", //确认按钮的文字
              showCancelButton: false, //是否显示取消按钮
              showClose: false, //是否显示关闭按钮
              closeOnClickModal: false, //是否可以通过点击空白处关闭弹窗
              type: "error",
            });
            return;
          }

          let nTotalFirst = that.params.firstZtcbVariety + that.params.firstWlcbVariety;
          let nTotalSecond = that.params.secondZtcbVariety + that.params.secondWlcbVariety;
          let bTotalCheckFirst = that.params.firstPublicationVariety != nTotalFirst;
          let bTotalCheckSecond = that.params.secondPublicationVariety != nTotalSecond;
          // zym.注释 start
          // if (bTotalCheckFirst || bTotalCheckSecond) {
          //   that.$confirm('请确认出版品种数填写的是否正确。', '提示', {
          //     confirmButtonText: '确定', //确认按钮的文字
          //     showCancelButton: false, //是否显示取消按钮
          //     showClose: false, //是否显示关闭按钮
          //     closeOnClickModal: false, //是否可以通过点击空白处关闭弹窗
          //     type: 'error'
          //   });
          //   return
          // };
          // zym.注释 end

          let msg = "请再次确认页面中所输入的金额单位为万元。";
          that
            .$confirm(msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              tabUpdate3({
                // pfinance: this.params,
                // 代码通用模块化
                data: that.params,
                organizationPersonnel: that.declare,
                // 身份验证要用
                publishMaterialId: that.params.publishMaterialId,
              })
                .then((response) => {
                  let tipCode = response.payload.pfinance.code;
                  let tipMessage = response.payload.pfinance.message;

                  that.submiting = false;
                  if (tipCode == -1) {
                    that.$message.error(`保存错误: ${tipMessage}`);
                    return;
                  }

                  this.$message({
                    message: "保存成功！",
                    type: "success",
                  });

                  this.goBack();
                })
                .catch((error) => {
                  that.submiting = false;
                });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },

    goBack: function () {
      for (let key in this.params) {
        this.params[key] = "";
      }
      this.$router.go(-1);
      // let pathStr = 'audio_press';
      // if(this.$route.query.pressType == 2){
      //     pathStr = 'elect_press';
      // }
      // this.$router.push({
      //   path:pathStr
      // });
    },
    tabReEdit: function () {
      tabRead3({ publishMaterialId: this.$route.query.mtId }).then((response) => {
        console.log("response=", response);
        if (response.pfinance) {
          // 新增
          if (this.$route.query.pgress == 1) {
            // 处理年份
            this.yearSet.year1 = response.pfinance.firstYear;
            this.yearSet.year2 = Number(response.pfinance.firstYear) + 1;
          } else {
            this.params = response.pfinance;

            // 处理年份
            this.yearSet.year1 = this.params.firstYear;
            this.yearSet.year2 = Number(this.params.firstYear) + 1;

            if (response.pOrganizationPersonnel !== null) {
              this.declare.contact = response.pOrganizationPersonnel.contact;
              this.declare.personnel = response.pOrganizationPersonnel.personnel;
              this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
            }
          }
        }
      });
    },
  },
  created: function () {
    let newDate = new Date();
    // this.yearSet.year1 = newDate.getFullYear() - 2
    // this.yearSet.year2 = newDate.getFullYear() - 1
    this.pubStatus = this.$route.query.pubStatus;
    // if (this.$route.query.pgress == 2) {
    this.tabReEdit();
    // }
  },

  // beforeDestroy:function(){
  // 		 for(let key in this.params){
  // 					this.params[key] = '';
  // 		 }
  // }
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table3 .editArea {
  text-align: center;
}

.table3 .editArea table {
  width: 80%;
  margin: 30px auto;
  border-collapse: collapse;
}

.table3 .editArea table td {
  border: 1px solid #e8e8e8;
  height: 45px;
}

.table3 .el-input-number {
  width: 240px;
}

.table3 .el-input-number input {
  border-radius: 0px;
}

.table3 {
  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;
    margin-top: 12px;
  }

  .newEditArea {
    width: 80%;
    margin: 0 auto;
    padding: 30px;

    .editBox {
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        float: left;
        width: 100px;
        text-align: right;
      }

      .edInp {
        width: 300px;
        float: left;
        margin: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// table3.vue?3e6bf318